<template>
    <div class="swiper-slide">
        <div class="box d-flex justify-content-center flex-column">
            <div>
            <a data-bs-toggle="modal" :data-bs-target="'#' + entry.id">
                <picture>
                <source type="image/webp" :srcset="entry.imageWeb">
                <img loading="lazy" :src="entry.imageWeb" :alt="entry.alt" class="overview-img">
                </picture>
            </a>
            </div>

            <div class="box--text">
            <p>{{ section.type }}</p>
            <a class="read-more--link" data-bs-toggle="modal" :data-bs-target="'#' + entry.id"><h4>View more</h4> <i class="fa-regular fa-chevron-right"></i></a>
            
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['entry', 'section']
    }
</script>